import { render, staticRenderFns } from "./detailed_form_item.vue?vue&type=template&id=0634aebc&scoped=true&"
import script from "./detailed_form_item.vue?vue&type=script&lang=js&"
export * from "./detailed_form_item.vue?vue&type=script&lang=js&"
import style0 from "./detailed_form_item.vue?vue&type=style&index=0&id=0634aebc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0634aebc",
  null
  
)

export default component.exports